module.exports = __webpack_public_path__ + "static/media/Regulator.1f435ce6.svg";